import ReactGA4 from 'react-ga4';

export const configureGoogleAnalytics = (user_id: string, TRACKING_ID: string) => {
  gtag('config', TRACKING_ID, { user_id });
  ReactGA4.initialize(TRACKING_ID);
};

export const configureGATrackingIDsForEnv = (client: string, userID: string, environment: string) => {
  if (environment === 'fila,native') {
    switch (client) {
      case 'haleon':
        configureGoogleAnalytics(userID, 'G-B4LWBLQ8ZG');
        break;
      case 'purina':
        configureGoogleAnalytics(userID, 'G-BQV9S87LPL');
        break;
      case '3m':
        configureGoogleAnalytics(userID, 'G-7PKYT3JX1J');
        break;
      case 'pgeu':
        configureGoogleAnalytics(userID, 'G-7J97QTXR4X');
        break;
      case 'glanbia':
        configureGoogleAnalytics(userID, 'G-27267EVNJC');
        break;
      case 'newell':
        configureGoogleAnalytics(userID, 'G-1VESB54TW4');
        break;
    }
  } else if (environment === 'staging,native') {
    switch (client) {
      case 'haleon':
        configureGoogleAnalytics(userID, 'G-QNVW90T2Q4');
        break;
      case 'purina':
        configureGoogleAnalytics(userID, 'G-N0RLLF9RSY');
        break;
      case '3m':
        configureGoogleAnalytics(userID, 'G-ZLHT71MXKG');
        break;
      case 'pgeu':
        configureGoogleAnalytics(userID, 'G-69MYTW90F0');
        break;
      case 'glanbia':
        configureGoogleAnalytics(userID, 'G-V6HYYTDQR5');
        break;
      case 'newell':
        configureGoogleAnalytics(userID, 'G-SCTKW01M7F');
        break;
    }
  } else if (environment === 'qa,native') {
    switch (client) {
      case 'haleon':
        configureGoogleAnalytics(userID, 'G-4KDK599DZ8');
        break;
      case 'purina':
        configureGoogleAnalytics(userID, 'G-0DNQB5S4M2');
        break;
      case '3m':
        configureGoogleAnalytics(userID, 'G-5QPBCY1X4P');
        break;
      case 'pgeu':
        configureGoogleAnalytics(userID, 'G-8T541WDER1');
        break;
      case 'glanbia':
        configureGoogleAnalytics(userID, 'G-YK7MBD1W62');
        break;
      case 'newell':
        configureGoogleAnalytics(userID, 'G-1J1ZP40YPT');
        break;
    }
  } else if (environment === 'dev') {
    switch (client) {
      case 'haleon':
        configureGoogleAnalytics(userID, 'G-GSBDBKG7P3');
        break;
      case '3m':
        configureGoogleAnalytics(userID, 'G-HRQ9L7E59F');
        break;
      case 'pgeu':
        configureGoogleAnalytics(userID, 'G-H6TG7BP0YT');
        break;
      case 'glanbia':
        configureGoogleAnalytics(userID, 'G-Y4WF4Q8S48');
        break;
    }
  }
};
